const swaggerParser = require('swagger-parser');

async function getData(urlOrCode) {
    if (!urlOrCode.startsWith("http")) {
        return  await swaggerParser.parse(JSON.parse(urlOrCode));
    }
    
    return await swaggerParser.parse(urlOrCode);
}
exports.getData = getData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/resttestsgenerator/src/swaggerDataProvider.js
// module id = jbT7
// module chunks = 0